import React from 'react';
import NeighborsUserItem from '../NeighborsUserItem';
import BlockedUserItem from '../BlockedUserItem';
import LoadingState from '../LoadingState';
import EmptyState from '../EmptyState';

const NeighborsSection = ({
  myNeighbors,
  blockedUsers,
  isNeighborsLoading,
  onRefresh,
  onRemoveNeighbor,
  onBlockNeighbor,
  onUnblock,
}) => {
  return (
    <div className="space-y-6 md:space-y-8">
      <div className="bg-card rounded-lg shadow-gaming-md p-5 md:p-6">
        <div className="flex items-center justify-between gap-3">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground">내 이웃</h2>
            <p className="text-sm text-muted-foreground caption mt-1">이웃을 제거하거나 영구차단할 수 있습니다</p>
          </div>
          <button
            type="button"
            onClick={onRefresh}
            className="px-4 py-2 rounded-md bg-muted/40 text-foreground hover:bg-muted transition-gaming"
          >
            새로고침
          </button>
        </div>

        <div className="mt-5 space-y-2">
          {isNeighborsLoading ? (
            <LoadingState message="로딩 중..." />
          ) : (myNeighbors || []).length === 0 ? (
            <EmptyState message="이웃이 없습니다." />
          ) : (
            (myNeighbors || []).map((n) => (
              <NeighborsUserItem
                key={n.id}
                userItem={n}
                primaryActionLabel="제거"
                onPrimaryAction={() => onRemoveNeighbor?.(n.id)}
                secondaryActionLabel="영구차단"
                onSecondaryAction={() => onBlockNeighbor?.(n.id)}
              />
            ))
          )}
        </div>
      </div>

      <div className="bg-card rounded-lg shadow-gaming-md p-5 md:p-6">
        <div>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground">차단 목록</h2>
          <p className="text-sm text-muted-foreground caption mt-1">차단 해제 후 다시 이웃을 추가할 수 있습니다</p>
        </div>

        <div className="mt-5 space-y-2">
          {isNeighborsLoading ? (
            <LoadingState message="로딩 중..." />
          ) : (blockedUsers || []).length === 0 ? (
            <EmptyState message="차단한 사용자가 없습니다." />
          ) : (
            (blockedUsers || []).map((b) => (
              <BlockedUserItem key={b.id} userItem={b} onUnblock={() => onUnblock?.(b.id)} />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default NeighborsSection;
